import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../services/api';
import { Link } from 'react-router-dom';
import pkg from '../../package.json';
import './Footer.css';

export default function Footer() {
  const loc = useLocation();
  const [ongelezen, setOngelezen] = useState(0);
  useEffect(() => { api.get('/nieuws/ongelezen').then((r) => setOngelezen(r.data.aantal || 0)).catch(() => {}); }, [loc.pathname]);
  return (
    <footer className="app-footer">
      <span>© {new Date().getFullYear()} WOMsys v{pkg.version}</span>
      <nav>
        <Link to="/nieuw">📰 Nieuws{ongelezen > 0 && <span style={{ marginLeft: 6, background: '#ef4444', color: '#fff', borderRadius: 10, padding: '1px 7px', fontSize: 11, fontWeight: 700 }}>{ongelezen}</span>}</Link>
        <Link to="/ideeen">💡 Ideeën</Link>
        <a href="https://womsys.nl/privacy" target="_blank" rel="noreferrer">Privacy</a>
        <a href="mailto:support@womsys.nl">Support</a>
      </nav>
    </footer>
  );
}
